export const LoginStatus = {
  UnAuthenticated: "UnAuthenticated",
  Pending: "Pending",
  Authorized: "Authorized",
  UnAuthorized: "UnAuthorized",
  LoggingOut: "LoggingOut",
  TenantSelection: "TenantSelection",
};
